export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M38.7 39.87v-2.04l1.65-1.2C45.34 33 48 27.86 48 22.58 48 12.85 38.68 4 26 4S4 12.85 4 22.58c0 9.73 9.32 18.57 22 18.57.67 0 1.4-.03 2.22-.1l1.12-.1 1 .5 8.36 4.12v-5.7zm4 12.13l-4-1.97-10.13-5c-.93.08-1.77.12-2.57.12-14.34 0-26-10.12-26-22.57C0 10.13 11.66 0 26 0s26 10.13 26 22.58c0 6.69-3.38 12.98-9.3 17.29V52zM19 18c0-1.1.9-2 2-2h15a2 2 0 012 2v10a2 2 0 01-2 2H21a2 2 0 01-2-2v-1l-4.55 2.28a1 1 0 01-1.45-.9V17.62a1 1 0 011.45-.9L19 19v-1z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "52",
    "height": "52",
    "viewBox": "0 0 52 52"
  }
};